module.exports = __webpack_public_path__ + "img/ic_services_fitnesscenter.4e248114.svg";